// 仓库
export const INCREASEWAREHOUSE = 'INCREASEWAREHOUSE' // 新增仓库
export const QUERYDISPATCHPLATFORM = 'QUERYDISPATCHPLATFORM' // 配送平台
export const DELETEENTERWAREHOUSE = 'DELETEENTERWAREHOUSE' // 删除仓库
export const WAREHOUSEDETAILS = 'WAREHOUSEDETAILS' // 查询详细信息
export const SELECTWAREHOUSELIST = 'SELECTWAREHOUSELIST' // 查询列表
export const BATCHAUDIT = 'BATCHAUDIT' // 通过or不通过 仓库
export const UPDATEYEWORDER = 'UPDATEYEWORDER' // 修改序号
// 供应商
export const QUERYVARIETIES = 'QUERYVARIETIES'// 查看主营品类
export const INCREASESUPPLIER = 'INCREASESUPPLIER'// 新增供应商
export const DELETEENTERSUPPLIER = 'DELETEENTERSUPPLIER' // 删除供应商
export const BATCHAUDITSUPPLIER = 'BATCHAUDITSUPPLIER'// 通过or不通过 供应商
export const SELECTSUPPLIERLIST = 'SELECTSUPPLIERLIST' // 供应商列表
export const SUPPLIERDETAILS = 'SUPPLIERDETAILS' // 供应商详情
export const UPDATEYEWORDERBYSUPPLIER = 'UPDATEYEWORDERBYSUPPLIER' // 修改序号

// 信息配置
export const UPDATEYCSHARECONFIG = 'UPDATEYCSHARECONFIG' // 保存
export const SELECTYCSHARECONFIG = 'SELECTYCSHARECONFIG'// 查询



// WEBPACK FOOTER //
// ./src/store/officialAccountManage/types.js